<template>
  <div class="personalize-vue">
    <div class="personalize-wrapper" v-if="personalized">
      <div class="personalize-wrapper-header">
        <h3 v-text="wrapper_title"></h3>
        <span v-text="pz_price"></span>
      </div>
      <div class="personalize-wrapper-selections">
        <ul>
          <li v-for="selectedLine in this.pzFormData">
            {{selectedLine.line_desc}}: {{transformVal(selectedLine)}}
          </li>
        </ul>
      </div>
      <div class="personalize-wrapper-confirmed">
        <input type="checkbox" id="pz-confirmed" @click="verifySpelling" />
        <label for="pz-confirmed" v-text="wrapper_policy"></label>
      </div>
      <a class="link-primary" v-text="wrapper_btn_edit" @click="viewForm()"></a>
    </div>

    <div class="personalize-wrapper" v-else>
      <div class="personalize__form--header">
        <div>
          <span>pz</span>
          <h3 v-text="wrapper_title"></h3>
        </div>
        <span class="_price" v-text="pz_price"></span>
      </div>

      <div class="personalize-wrapper-options" v-if="hasNoPZ">
        <ul>
          <li>
            <input type="radio" name="start_pz" id="no_personalization" value="0" checked @click="selectOpt" />
            <label for="no_personalization" v-text="wrapper_opt_no"></label>
          </li>
          <li>
            <input type="radio" name="start_pz" id="personalized_start" value="1" @click="selectOpt" />
            <label for="personalized_start" v-text="wrapper_opt_yes"></label>
            <span v-text="wrapper_opt_yes_surfix"></span>
          </li>
        </ul>
      </div>
    </div>
    <PzForm :sku="pz_sku" :show="started" @priceStatus="changePrice" @modalClose="closeModal" @modalStatus="changeModalStatus" @personalizedStatus="changePZStatus" />
  </div>
</template>

<script>

const {
  PZ_SKU,
  PZ_FEE_PRODUCT,
  PZ_WRAPPER_TITLE, 
  PZ_WRAPPER_POLICY,
  PZ_WRAPPER_BTN_EDIT,
  PZ_WRAPPER_OPTR_NO,
  PZ_WRAPPER_OPTR_YES,
  PZ_WRAPPER_OPTR_YES_SURFIX,
  SLIDE_COUNTS
} = window;

import { mapState, mapMutations } from 'vuex'
import PzForm from './components/pz-form.vue';

import preview from './preview';

export default {
  data () {
    return {
      pz_sku: PZ_SKU,
      pz_price: '',
      pz_fee_product: PZ_FEE_PRODUCT,
      wrapper_title: PZ_WRAPPER_TITLE,
      wrapper_policy: PZ_WRAPPER_POLICY,
      wrapper_btn_edit: PZ_WRAPPER_BTN_EDIT,
      wrapper_opt_yes_surfix: PZ_WRAPPER_OPTR_YES_SURFIX,
      wrapper_opt_no: PZ_WRAPPER_OPTR_NO,
      wrapper_opt_yes: PZ_WRAPPER_OPTR_YES,
      started: false,
      personalized: false,
      engravingW: 600,
      engravingH: 600,
      slide_counts: SLIDE_COUNTS
    }
  },
  components: {
    PzForm
  },
  mounted() {
    window.PZ_STYLECODE = 'NOPERSONAL';
  },
  computed: {
    ...mapState([
      'pzData',
      'pzFormData'
    ]),
    hasNoPZ() {
      if(typeof this.pzData.pzlines != 'undefined') {
        let has_no_pz = false;
        this.pzData.pzlines.map(function (line) {
          if(line.style_code == 'NOPERSONAL') {
            has_no_pz = true;
          }
        });
        if (!has_no_pz) {
          this.started = true;
          $('.js-product-btn').prop('disabled', true);
        }
        return has_no_pz;
      } else {
        return true;
      }
    }
  },
  methods: {
    changePrice(price){
      if (price == '.00') {
        this.pz_price = '+$0.00';
      } else {
        this.pz_price = '+$' + price;
      }
    },
    viewForm() {
      if (this.hasNoPZ) {
        $('.section-product .section__content').addClass('pz-show');
      } else {
        this.personalized = false;
      }

      this.started = true;

      if($('#pz-confirmed').prop('checked')) {
        $('#pz-confirmed').trigger('click');
      }
    },
    transformVal(obj) {
      if(obj.line_case == 'UPPER') {
        return obj.value.toUpperCase();
      } else {
        return obj.value;
      }
    },
    changeModalStatus(status) {
      this.started = status;
    },
    changePZStatus(status, previewable) {
      this.personalized = status

      window.PZ_SELECTIONED = this.pzFormData
      window.PZ_STYLECODE = '';

      if(previewable) {
        let preview_url = this.generatePreviewUrl();
        if(preview_url != '') {
          this.previewImage(preview_url);
        }
      }

      $('.js-product-btn').prop('disabled', true);
    },
    closeModal(status) {
      if(status) {
        $('#no_personalization').trigger('click');
        if($('.js-product-btn').data('available')) {
          $('.js-product-btn').prop('disabled', false);
        }
      }
    },
    previewImage(url) {
      if($('.section__thumb--pzimg').length > 0) {
        $('.section__thumb--pzimg figure').html('<img src="' + url + '&wid=122" alt="personalize" />');
        $('.section__image--pzimg figure').html('<img class="lazyload loaded" data-src="' + url + '" data-zoom-image="' + url + '" src="' + url + '" data-was-processed="true" />');
      } else {
        this.slide_counts++;
        $('.js-slider-thumbs').slick('slickAdd','<div><div><div class="thumb section__thumb section__thumb--pzimg" data-image-target="pzimg"><figure><img src="' + url + '&wid=122" alt="personalize" /></figure></div></div></div>');
        $('.js-slider-product').slick('slickAdd','<div><div><div class="section__image section__image--pzimg" data-image-target="pzimg"><figure><img class="lazyload loaded" data-src="' + url + '" data-zoom-image="' + url + '" src="' + url + '" data-was-processed="true" /></figure></div></div></div>');

        $('.js-slider-product').slick('refresh');
        $('.js-slider-thumbs').slick('refresh');
      }

      let slideIndex = $('.section__thumb--pzimg').data('slick-index');
      setTimeout(function(){ 
        $('.js-slider-thumbs').slick('slickGoTo', parseInt(slideIndex), false);
      }, 500);
    },
    selectOpt(e) {
      if(e.target.value == '1') {
        this.viewForm();
      } else {
        window.PZ_STYLECODE = 'NOPERSONAL';
      }
    },
    verifySpelling(e) {
      if($('#pz-confirmed').prop('checked')) {
        if($('.js-product-btn').data('available')) {
          $('.js-product-btn').prop('disabled', false);
        }
      } else {
        $('.js-product-btn').prop('disabled', true);
      }
    },
    generateParams() {
      let params = [];
      let param = null,
          type = '',
          value = '';
      this.pzFormData.forEach(function (item) {
        type = 'string';
        if(item.line_case.toLowerCase().search('font') != -1) {
          type = 'font';
        }

        value = item.value;
        if(item.line_case == 'UPPER') {
          value = value.toUpperCase();
        }

        param = {
          type: type,
          value: value
        };
        params.push(param);
      });

      return params;
    },
    generatePreviewUrl() {
      let preview_url = '';

      let style_code = this.pzFormData[0].style_code;
      let style_code_prefix = style_code.substring(0,3).toLowerCase();
      let params = [];
      // switch(style_code_prefix) {
      //  case 'txt':
          params = this.generateParams();
          try {
            preview_url = preview.previewEngraving(this.pz_sku, style_code, params, this.engravingW, this.engravingH);
          }
          catch(err) {
            preview_url = '';
          }
      //    break;
      //  default:

          if(preview_url == '') {
            try {
              preview_url = preview.previewReednBarton(this.pz_sku, style_code, params);
            }
            catch(err) {
              preview_url = '';
            }
          }
      //    break;
      // }

      return preview_url;
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../assets/js/personalize/app.vue